<template>
  <div>
    <div v-if="['Home', 'Login', 'ResetPassword'].includes($route.name)">
      <BannerPolicies></BannerPolicies>
    </div>
    <footer
      id="main-footer"
      class="bg-dark text-white footer"
      :class="{ 'app-footer--brand': hamburgerMenuEnabled }"
    >
      <b-row>
        <b-col>
          <div class="copyright py-1 text-center">
            © {{ currentYear }} | LimeIQ LLC | All Rights Reserved. |
            <a
              class="text-white"
              @click.prevent.stop="$emitter.emit('toggle-termly-modal', 'privacy-policy')"
              href="#"
              >Privacy Policy</a
            >
            |
            <a
              href="#"
              class="text-white"
              @click.prevent.stop="
                $emitter.emit('toggle-termly-modal', 'terms-and-conditions')
              "
              >Terms & Conditions</a
            >
            <template v-if="hamburgerMenuEnabled">
              |
              <a
                href="https://www.limeiq.com"
                class="text-white"
                target="_blank"
                rel="noopener noreferrer"
                >limeiq.com</a
              >
            </template>
          </div>
        </b-col>
      </b-row>
    </footer>
  </div>
</template>

<script>
import BannerPolicies from "../components/BannerPolicies.vue";
import { isHamburgerMenuEnabled } from "@/config/navMenu";

export default {
  name: "app-footer",
  components: {
    BannerPolicies,
  },
  data() {
    return {
      currentYear: new Date().getFullYear(),
      // The new footer (LIQ-2643) ships with the new menu, behind the same flag.
      hamburgerMenuEnabled: isHamburgerMenuEnabled(),
    };
  },
};
</script>

<style lang="scss">
// Deep cyan footer (LimeIQ Design System, LIQ-2643). Not scoped: bg-dark and text-white are
// !important utilities.
#main-footer.app-footer--brand {
  background-color: var(--liq-deep) !important;
  font-family: var(--liq-font-sans);
  font-size: 13.5px;

  a.text-white:hover {
    color: var(--liq-mint) !important;
  }

  @media (max-width: 640px) {
    font-size: 11px;
  }
}
</style>
